import React from "react";
import LoginForm from "../../containers/login/LoginForm";

import "../../index.css";
import "../../App.css";
import { Layout } from "antd";

const { Content } = Layout;

function Login() {
  return (
    <Layout>
      <Content className="login-bg">
        <LoginForm />
      </Content>
    </Layout>
  );
}

export default Login;
